import React, { useEffect, useRef, useState } from "react";
import FroalaEditor from "react-froala-wysiwyg";

// CSS (make sure your bundler loads these)
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/plugins.pkgd.min.js"; // All plugins

import TextInput from "../../../../components/common/ui/Inputs/TextInput";
import RadioInput from "../../../../components/common/ui/Inputs/RadioInput";
import FileInput from "../../../../components/common/ui/Inputs/FileInput";
// import ReactQuill, { Quill } from "react-quill";
import Button from "../../../../components/common/ui/Button";
import { history } from "../../../../_helpers";
import { useSelector, useDispatch } from "react-redux";
import { committeeActions } from "../../../../_store/committee.slice";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import CommitteeHomePageIntegrationSchema from "../../../../validation/Admin/CommitteHomePageIntegrationSchema";
import Swal from "sweetalert2";
import { config } from "../../Editor_Config/Froalaconfig";
import { useParams } from "react-router-dom";
import CustomLoader from "../../../../components/common/ui/Loader";
import SelectInput from "./../../../../components/common/ui/Inputs/SelectInput";

function CommitteeHomePage() {
  const [bannerImage, setBannerImage] = useState("");
  const { textEditorTemplate } = useSelector((x) => x?.home);

  const { ColTwoAlginments, ColThreeAlginments, editorColumn } = useSelector(
    (x) => x?.dropDown
  );

  const [sectionOneImg, setSectionOneImg] = useState("");
  const [sectionFourImg, setSectionFourImg] = useState("");
  const [sectionFiveCardImg1, setSectionFiveCardImg1] = useState("");
  const [sectionFiveCardImg2, setSectionFiveCardImg2] = useState("");
  const [sectionFiveCardImg3, setSectionFiveCardImg3] = useState("");
  const [sectionFiveCardImg4, setSectionFiveCardImg4] = useState("");

  // section dropdown
  const [secOneFilter, setSecOneFilter] = useState({
    Column: null,
    ContentAlignment: "",
  });
  const [secTwoFilter, setSecTwoFilter] = useState({
    Column: null,
    ContentAlignment: "",
  });

  const [secThreeFilter, setSecThreeFilter] = useState({
    Column: null,
    ContentAlignment: "",
  });

  const dispatch = useDispatch();
  const isFirstRender = useRef(true);
  const lastValueRef = useRef({});
  const { ButtonTarget } = useSelector((x) => x?.dropDown);

  const [errorMessage, setErrorMessage] = useState({});
  const [isPending, setIsPending] = useState(false);

  // const [isDataInitialized, setIsDataInitialized] = useState(false);
  const [editorStates, setEditorStates] = useState({
    committeeSectionOneDescription: "",
    committeeSectionTwoDescription: "",
    committeeSectionThreeDescription: "",

    committeeSectionFiveCardOneDescription: "",
    committeeSectionFiveCardTwoDescription: "",
    committeeSectionFiveCardThreeDescription: "",
    committeeSectionFiveCardFourDescription: "",
  });
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;

  const committeeHomePage = useSelector(
    (x) => x?.committee?.getCommitteeHomePageIntegrationDataResponse?.data
    // ?.committeeHomePage
  );
  const { loading } = useSelector((x) => x?.committee);
  // console.log("committeeHomePage", committeeHomePage);
  const { commiteePageID } = useParams();
  // const config = {
  //   // key: `${process.env.REACT_APP_API_Froala_Key}`, // Key for Froala
  //   placeholderText: "Start typing...",
  //   charCounterCount: true,
  //   toolbarButtons: [
  //     "bold",
  //     "italic",
  //     "underline",
  //     "strikeThrough",
  //     "subscript",
  //     "superscript",
  //     "|",
  //     "fontFamily",
  //     "fontSize",
  //     "color",
  //     "inlineStyle",
  //     "paragraphStyle",
  //     "|",
  //     "paragraphFormat",
  //     "align",
  //     "formatOL",
  //     "formatUL",
  //     "outdent",
  //     "indent",
  //     "quote",
  //     "|",
  //     "insertLink",
  //     "insertImage",
  //     "insertVideo",
  //     "insertFile",
  //     "insertTable",
  //     "|",
  //     "emoticons",
  //     "specialCharacters",
  //     "embedly",
  //     "insertHR",
  //     "selectAll",
  //     "clearFormatting",
  //     "|",
  //     "print",
  //     "spellChecker",
  //     "help",
  //     "html",
  //     "|",
  //     "undo",
  //     "redo",
  //   ],
  //   toolbarButtonsXS: null,
  //   toolbarButtonsSM: null,
  //   toolbarButtonsMD: null,
  //   imageUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,
  //   // `

  //   // Video upload endpoint (if needed)
  //   videoUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,

  //   // File upload endpoint
  //   fileUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,

  //   // Extra settings
  //   imageUploadParam: "file", // 👈 match multer field name
  //   fileUploadParam: "file",
  //   videoUploadParam: "file",
  //   events: {
  //     "image.uploaded": function (response) {
  //       const res = JSON.parse(response);
  //       debugger;
  //       if (res.link) {
  //         this.image.insert(
  //           `${process.env.REACT_APP_API_IMAGE_URL}${res.link}`, // ✅ use IMAGE_URL, not API_URL
  //           true,
  //           null,
  //           this.image.get(),
  //           response
  //         );
  //         return false; // prevent Froala default insert
  //       }
  //     },
  //   },

  //   // Example: image upload endpoint on your server

  //   // Additional options you might use:
  //   // imageAllowedTypes: ['jpeg', 'jpg', 'png'],
  //   // fileUploadURL: '/api/uploads/froala-file',
  //   //
  // };

  //   const Size = Quill.import("attributors/style/size");
  //   var Font = Quill.import("formats/font");

  //   Font.whitelist = [
  //     "arial",
  //     "courier-new",
  //     "georgia",
  //     "tahoma",
  //     "times-new-roman",
  //     "verdana",
  //     "impact",
  //     "wingdings",
  //   ];

  //   Size.whitelist = [
  //     "8pt",
  //     "10pt",
  //     "12pt",
  //     "14pt",
  //     "18pt",
  //     "24pt",
  //     "36pt",
  //     "48px",
  //   ];

  //   Quill.register(Size, true);

  //   const modules = {
  //     toolbar: [
  //       [{ font: Font.whitelist }],
  //       [{ size: Size.whitelist }],
  //       ["bold", "italic", "underline", "strike", "blockquote"],
  //       [{ list: "ordered" }, { list: "bullet" }],
  //       [{ script: "sub" }, { script: "super" }],
  //       [{ indent: "-1" }, { indent: "+1" }],
  //       [{ direction: "rtl" }],
  //       [{ color: [] }, { background: [] }],
  //       [{ align: [] }],
  //       ["link"],
  //       ["clean"],
  //       ["code-block"],
  //       ["htmlEditButton"],
  //     ],
  //     clipboard: {
  //       matchVisual: false,
  //     },
  //   };

  //   const CustomStyles = `
  // .ql-picker.ql-font .ql-picker-label::before,
  // .ql-picker.ql-font .ql-picker-item::before {
  //     font-family: initial !important;  /* Reset to default font */
  //     content: attr(data-value) !important;  /* Show font name */
  //     text-transform: capitalize !important;  /* Capitalize first letter */
  //     font-size: 16px !important;  /* Increase font size */
  // }

  //   .ql-picker.ql-font { width: 160px !important; }

  //     .ql-picker.ql-size .ql-picker-label::before,
  //     .ql-picker.ql-size .ql-picker-item::before {
  //         content: attr(data-value) !important;
  //         text-transform: none !important;
  //     }
  //         .ql-font-arial { font-family: Arial, sans-serif; }
  //         .ql-font-courier-new { font-family: Courier-New, monospace; }
  //         .ql-font-georgia { font-family: Georgia, serif; }
  //         .ql-font-tahoma { font-family: Tahoma, sans-serif; }
  //         .ql-font-times-new-roman { font-family: Times-New-Roman, serif; }
  //         .ql-font-verdana { font-family: Verdana, sans-serif; }
  //         .ql-font-impact { font-family: Impact, sans-serif; }
  //         .ql-font-wingdings { font-family: Wingdings; }

  //          /* Hide only the preview inside the tooltip */
  //         .ql-tooltip .ql-preview {
  //             max-width: 7px !important;
  //             height: 0px !important;
  //             overflow: hidden !important;
  //             white-space: nowrap !important;
  //             display: inline-block !important;
  //             visibility: hidden; /* Hides text but keeps the element */
  //         }
  //         .ql-snow .ql-tooltip::before {
  //             content: none !important; /* Removes the "Visit URL:" text */
  //         }
  //       .ql-snow .ql-tooltip a.ql-action::after {
  //           border-right: 1px solid #ccc;
  //           content: 'Edit';
  //           margin-left: 7px;
  //           padding-right: 8px;
  //       }
  // `;

  useEffect(() => {
    Swal.close();
  }, []);

  useEffect(() => {
    // if (committeeHomePage && !isDataInitialized) {
    if (committeeHomePage) {
      setEditorStates({
        committeeSectionOneDescription:
          committeeHomePage.committeeSectionOneDescription || "",
        committeeSectionTwoDescription:
          committeeHomePage.committeeSectionTwoDescription || "",
        committeeSectionThreeDescription:
          committeeHomePage.committeeSectionThreeDescription || "",
        committeeSectionFourDescription:
          committeeHomePage.committeeSectionFourDescription || "",
        committeeSectionFiveCardOneDescription:
          committeeHomePage.committeeSectionFiveCardOneDescription || "",
        committeeSectionFiveCardTwoDescription:
          committeeHomePage.committeeSectionFiveCardTwoDescription || "",
        committeeSectionFiveCardThreeDescription:
          committeeHomePage.committeeSectionFiveCardThreeDescription || "",
        committeeSectionFiveCardFourDescription:
          committeeHomePage.committeeSectionFiveCardFourDescription || "",
        committeeSectionSixDescription:
          committeeHomePage.committeeSectionSixDescription || "",
        committeeSectionSevenDescription:
          committeeHomePage.committeeSectionSevenDescription || "",
      });
      // setIsDataInitialized(true);
    }
    // }, [committeeHomePage, isDataInitialized]);
  }, [committeeHomePage]);

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  // const handleEditorChanges = (content, name) => {
  //   if (isFirstRender.current) return;
  //   const cleanedContent = content.replace(/^(<p>(&nbsp;|\s)*<\/p>)+/, "");
  //   setEditorStates((prev) => ({
  //     ...prev,
  //     [name]: cleanedContent,
  //   }));

  //   // Do not dispatch if unchanged
  //   if (committeeHomePage?.[name] === cleanedContent || !committeeHomePage)
  //     return;

  //   dispatch(
  //     committeeActions?.updateCommitteeHomePageReponseData({
  //       ...committeeHomePage,
  //       [name]: cleanedContent,
  //     })
  //   );
  // };

  const handleFroalaEditorChanges = (content, name) => {
    if (isFirstRender.current) return;
    const cleanedContent = content.replace(/^(<p>(&nbsp;|\s)*<\/p>)+/, "");
    setEditorStates((prev) => ({
      ...prev,
      [name]: cleanedContent,
    }));
  };

  // const handleChange = (e, nameToShow) => {
  //   debugger;
  //   const { name, value, type } = e?.target;
  //   const pageData = { ...committeeHomePage };
  //   if (type === "file") {
  //     const file = e.target.files[0];
  //     const formData = new FormData();
  //     formData.append("image", file);
  //     if (name === "committeeBannerImage") {

  //       setBannerImage(file);
  //     }
  //     if (name === "committeeSectionOneImage") {
  //       setSectionOneImg(file);
  //     }
  //     if (name === "committeeSectionFourImage") {
  //       setSectionFourImg(file);
  //     }
  //     if (name === "committeeSectionFiveCardOneImage") {
  //       setSectionFiveCardImg1(file);
  //     }
  //     if (name === "committeeSectionFiveCardTwoImage") {
  //       setSectionFiveCardImg2(file);
  //     }
  //     if (name === "committeeSectionFiveCardThreeImage") {
  //       setSectionFiveCardImg3(file);
  //     }
  //     if (name === "committeeSectionFiveCardFourImage") {
  //       setSectionFiveCardImg4(file);
  //     }
  //     if (file) {
  //       const imageUrl = URL.createObjectURL(file);
  //       pageData[nameToShow] = imageUrl;
  //     }
  //   } else {
  //     pageData[name] = value;
  //   }
  //   //dispatch(committeeActions?.updateCommitteeHomePageReponseData(pageData));
  //   dispatch(committeeActions?.updateCommitteeHomePageReponseData(pageData));
  // };

  const allowedMimeTypes = ["image/jpeg", "image/png", "image/webp"];

  const handleChange = (e, nameToShow) => {
    debugger;
    const { name, value, type } = e?.target;
    const pageData = { ...committeeHomePage };

    if (type === "file") {
      let file = e.target.files[0];
      if (!file) return;

      if (allowedMimeTypes.includes(file.type)) {
        pageData[nameToShow] = file;
        // pageData.fileCheck = { name: file.name, type: file.type || "" };
      } else {
        showToastNotification("Unsupported Media Type", "error");
        pageData[nameToShow] = undefined;
        // pageData.fileCheck = undefined;
        e.target.value = ""; // reset input field
        file = "";
        return;
      }

      const formData = new FormData();
      formData.append("image", file);

      if (name === "committeeBannerImage") {
        const img = new Image();
        img.onload = () => {
          const { width, height } = img;

          const minWidth = 1920 - 100;
          const maxWidth = 1920 + 100;
          const minHeight = 550 - 100;
          const maxHeight = 550 + 100;

          if (
            width < minWidth ||
            width > maxWidth ||
            height < minHeight ||
            height > maxHeight
          ) {
            showToastNotification(
              `❌ Invalid Banner Image size! 
Required: 1920×550 (±100px). 
Uploaded: ${width}×${height}`,
              "warning"
            );
            // reset input so user can re-pick
            e.target.value = "";
            return;
          }

          // ✅ Only set if valid
          setBannerImage(file);
          const imageUrl = URL.createObjectURL(file);
          pageData[nameToShow] = imageUrl;

          // Update Redux after validation
          dispatch(
            committeeActions?.updateCommitteeHomePageReponseData(pageData)
          );
        };

        // 🔑 This is required, otherwise onload won't fire
        img.src = URL.createObjectURL(file);
        return; // prevent falling through
      }

      // ✅ Other images (no size restriction)
      if (name === "committeeSectionOneImage") {
        setSectionOneImg(file);
      }
      if (name === "committeeSectionFourImage") {
        setSectionFourImg(file);
      }
      if (name === "committeeSectionFiveCardOneImage") {
        setSectionFiveCardImg1(file);
      }
      if (name === "committeeSectionFiveCardTwoImage") {
        setSectionFiveCardImg2(file);
      }
      if (name === "committeeSectionFiveCardThreeImage") {
        setSectionFiveCardImg3(file);
      }
      if (name === "committeeSectionFiveCardFourImage") {
        setSectionFiveCardImg4(file);
      }

      const imageUrl = URL.createObjectURL(file);
      pageData[nameToShow] = imageUrl;

      // dispatch(committeeActions?.updateCommitteeHomePageReponseData(pageData));
    } else {
      pageData[name] = value;
      // dispatch(committeeActions?.updateCommitteeHomePageReponseData(pageData));
    }
    pageData["committeeSectionOneDescription"] =
      editorStates.committeeSectionOneDescription;
    pageData["committeeSectionTwoDescription"] =
      editorStates.committeeSectionTwoDescription;
    pageData["committeeSectionThreeDescription"] =
      editorStates.committeeSectionThreeDescription;

    pageData["committeeSectionFiveCardOneDescription"] =
      editorStates.committeeSectionFiveCardOneDescription;
    pageData["committeeSectionFiveCardTwoDescription"] =
      editorStates.committeeSectionFiveCardTwoDescription;
    pageData["committeeSectionFiveCardThreeDescription"] =
      editorStates.committeeSectionFiveCardThreeDescription;
    pageData["committeeSectionFiveCardFourDescription"] =
      editorStates.committeeSectionFiveCardFourDescription;
    dispatch(committeeActions?.updateCommitteeHomePageReponseData(pageData));
  };

  const submitHomeTabContent = (e) => {
    debugger;
    setErrorMessage({});
    e?.preventDefault();
    setIsPending(true);
    const formData = new FormData();
    Object.keys(committeeHomePage).forEach((key) => {
      if (
        committeeHomePage[key] !== undefined &&
        committeeHomePage[key] !== null
      ) {
        if (key === "committeeSectionOneDescription") {
          formData.append(key, editorStates.committeeSectionOneDescription);
        } else if (key === "committeeSectionTwoDescription") {
          formData.append(key, editorStates.committeeSectionTwoDescription);
        } else if (key === "committeeSectionThreeDescription") {
          formData.append(key, editorStates.committeeSectionThreeDescription);
        } else if (key === "committeeSectionFiveCardOneDescription") {
          formData.append(
            key,
            editorStates.committeeSectionFiveCardOneDescription
          );
        } else if (key === "committeeSectionFiveCardTwoDescription") {
          formData.append(
            key,
            editorStates.committeeSectionFiveCardTwoDescription
          );
        } else if (key === "committeeSectionFiveCardThreeDescription") {
          formData.append(
            key,
            editorStates.committeeSectionFiveCardThreeDescription
          );
        } else if (key === "committeeSectionFiveCardFourDescription") {
          formData.append(
            key,
            editorStates.committeeSectionFiveCardFourDescription
          );
        } else {
          formData.append(key, committeeHomePage[key]);
        }
      }
    });
    if (bannerImage) {
      formData.append("committeeBannerImage", bannerImage);
    }
    if (sectionOneImg) {
      formData.append("committeeSectionOneImage", sectionOneImg);
    }
    if (sectionFourImg) {
      formData.append("committeeSectionFourImage", sectionFourImg);
    }
    if (sectionFiveCardImg1) {
      formData.append("committeeSectionFiveCardOneImage", sectionFiveCardImg1);
    }
    if (sectionFiveCardImg2) {
      formData.append(
        "committeeSectionFiveCardTwoImage",
        sectionFiveCardImg2 || "null"
      );
    }
    if (sectionFiveCardImg3) {
      formData.append(
        "committeeSectionFiveCardThreeImage",
        sectionFiveCardImg3
      );
    }
    if (sectionFiveCardImg4) {
      formData.append("committeeSectionFiveCardFourImage", sectionFiveCardImg4);
    }
    const { error } = CommitteeHomePageIntegrationSchema(committeeHomePage);
    console.log(error?.details);
    if (error?.details) {
      setIsPending(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    formData.forEach((value, key) => {
      console.log("Key:", key, "Value:", value);
    });

    //   for (let [key, value] of formData.entries()) {
    //   console.log("Key:", key, "Value:", JSON.stringify(value));
    // }

    dispatch(committeeActions.updateCommitteeHomePage(formData))
      .then((result) => {
        setIsPending(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch(() => {
        setIsPending(false);
        showToastNotification("Something went wrong", "error");
      });
  };

  const handleEditorFilter = (e, name, page) => {
    const value = e?.value;

    const columnMap = {
      1: { Column: 1, ContentAlignment: "" },
      2: { Column: 2, ContentAlignment: "left-4" },
      3: { Column: 3, ContentAlignment: "left" },
    };

    const setters = {
      1: setSecOneFilter,
      2: setSecTwoFilter,
      3: setSecThreeFilter,
    };

    const setter = setters[page];
    if (!setter) return; // safeguard

    setter((prev) => {
      if (name === "Column") {
        return {
          ...prev,
          ...(columnMap[value] || { Column: null, ContentAlignment: "" }),
        };
      }
      return { ...prev, ContentAlignment: value };
    });
  };

  const handleSearchSection = (e, status, name, column, alignment) => {
    e.preventDefault();
    debugger;
    const payload = { ...editorStates };
    const template = textEditorTemplate?.data;

    if (column === 1) {
      // Filter template for columnSplit = 1
      const htmlValue = template?.filter((d) => d.columnSplit === 1);
      if (htmlValue && htmlValue.length > 0) {
        payload[name] = htmlValue[0].html;
      }
    } else {
      // Filter template for columnSplit = 2
      const htmlValue = template?.filter(
        (d) => d.columnSplit === column && d.fileAlignment === alignment
      );
      if (htmlValue && htmlValue.length > 0) {
        payload[name] = htmlValue[0].html;
      }
    }

    // Dispatch update action
    setEditorStates(payload);
  };

  const handleReset = (e) => {
    e.preventDefault();
    // setIsDataInitialized(false);
    dispatch(
      committeeActions?.getCommitteeHomePageIntegrationData(commiteePageID)
    );
  };
  if (loading) return <CustomLoader />;
  return (
    <form
      onSubmit={(e) => {
        submitHomeTabContent(e);
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">
          {committeeHomePage?.committe?.committeeName}
        </h1>
        <Button
          label="Back"
          status="reset"
          onClick={() => {
            history?.navigate("/Admin/CommitteePage");
          }}
        />
      </div>

      {/* Banner */}
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
          Banner
        </h1>
        <div className="p-3 row">
          <div className="row mb-4">
            <div className="col-md-4 d-flex">
              <FileInput
                name="committeeBannerImage"
                label="Banner Image"
                imageURL={
                  committeeHomePage?.committeeBannerImageToShow === undefined
                    ? ImageURL + committeeHomePage?.committeeBannerImage
                    : committeeHomePage?.committeeBannerImageToShow
                }
                handleFileChange={(e) => {
                  handleChange(e, "committeeBannerImageToShow");
                }}
                required
              />
            </div>
            <p className="text-gray fs-6">
              Recommended Image Size: 1920 × 550 px
            </p>
          </div>
        </div>
      </div>

      {/* Session- 1 */}
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <div className="d-flex flex-wrap align-items-center border p-3 gap-3">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
            Section - 1
          </h1>
          <div className="col-4">
            <SelectInput
              options={editorColumn}
              label="Column"
              name="Column"
              handleChange={(e) => handleEditorFilter(e, "Column", 1)}
              value={secOneFilter?.Column}
            />
          </div>

          <div className="col-4">
            <SelectInput
              options={
                secOneFilter?.Column === 2
                  ? ColTwoAlginments
                  : ColThreeAlginments
              }
              label="Content Alignment"
              name="ContentAlignment"
              handleChange={(e) => handleEditorFilter(e, "ContentAlignment", 1)}
              value={secOneFilter?.ContentAlignment}
              isDisabled={
                secOneFilter?.Column === 1 || secOneFilter?.Column === undefined
              }
            />
          </div>
          <div className="col-2">
            <Button
              type="submit"
              label="Search"
              status="primary"
              className="mt-4"
              onClick={(e) => {
                handleSearchSection(
                  e,
                  1,
                  "committeeSectionOneDescription",
                  secOneFilter?.Column,
                  secOneFilter?.ContentAlignment
                );
              }}
            />
          </div>
        </div>

        <div className="p-3 row">
          <div className="row mb-4">
            <div className="col-md-12">
              <FroalaEditor
                tag="textarea"
                name="committeeSectionOneDescription"
                config={config} // your toolbar, plugins, etc.
                model={editorStates?.committeeSectionOneDescription || ""} // ✅ value binding
                onModelChange={(content) => {
                  // ✅ onChange equivalent
                  handleFroalaEditorChanges(
                    content,
                    "committeeSectionOneDescription"
                  );
                }}
                className={`editor-block ${errorMessage?.["committeeSectionOneDescription"]
                    ? "input-error"
                    : ""
                  }`}
              />

              {errorMessage?.committeeSectionOneDescription && (
                <div className="text-danger fw-700 fs-6 mt-1">
                  {errorMessage?.committeeSectionOneDescription}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Session- 2 */}
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <div className="d-flex flex-wrap align-items-center border p-3 gap-3">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
            Section - 2
          </h1>
          <div className="col-4">
            <SelectInput
              options={editorColumn}
              label="Column"
              name="Column"
              handleChange={(e) => handleEditorFilter(e, "Column", 2)}
              value={secTwoFilter?.Column}
            />
          </div>

          <div className="col-4">
            <SelectInput
              options={
                secTwoFilter?.Column === 2
                  ? ColTwoAlginments
                  : ColThreeAlginments
              }
              label="Content Alignment"
              name="ContentAlignment"
              handleChange={(e) => handleEditorFilter(e, "ContentAlignment", 2)}
              value={secTwoFilter?.ContentAlignment}
              isDisabled={
                secTwoFilter?.Column === 1 || secTwoFilter?.Column === undefined
              }
            />
          </div>
          <div className="col-2">
            <Button
              type="submit"
              label="Search"
              status="primary"
              className="mt-4"
              onClick={(e) => {
                handleSearchSection(
                  e,
                  2,
                  "committeeSectionTwoDescription",
                  secTwoFilter?.Column,
                  secTwoFilter?.ContentAlignment
                );
              }}
            />
          </div>
        </div>

        <div className="p-3 row">
          <div className="row mb-4">
            <div className="col-md-12">
              <FroalaEditor
                tag="textarea"
                name="committeeSectionTwoDescription"
                config={config} // your toolbar, plugins, etc.
                model={editorStates?.committeeSectionTwoDescription || ""} // ✅ value binding
                onModelChange={(e) => {
                  // ✅ onChange equivalent
                  handleFroalaEditorChanges(
                    e,
                    "committeeSectionTwoDescription"
                  );
                }}
                className={`editor-block ${errorMessage?.["committeeSectionTwoDescription"]
                    ? "input-error"
                    : ""
                  }`}
              />

              {errorMessage?.committeeSectionTwoDescription && (
                <div className="text-danger fw-700 fs-6 mt-1">
                  {errorMessage?.committeeSectionTwoDescription}
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <div className="p-3 row">
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                name="committeeSectionTwoTitle"
                label="Title"
                placeholder="Title"
                value={committeeHomePage?.committeeSectionTwoTitle}
                id="committeeSectionTwoTitle"
                handleChange={(e) => {
                  handleChange(e);
                }}
                required
                errorMessage={errorMessage}
              />
            </div>

            <div className="col-md-8">
              <label
                className={`form-label col-form-label  w-100 fs-5 form-label-custom-visible `}
              >
                Description {<span className="text-danger">*</span>}
              </label>

              <div className="quill-container" id="toolbar">
                <style>{CustomStyles}</style>
                <div>
                  <ReactQuill
                    theme="snow"
                    value={editorStates?.committeeSectionTwoDescription || ""}
                    onChange={(e) => {
                      handleEditorChanges(e, "committeeSectionTwoDescription");
                    }}
                    className={`editor-block ${
                      errorMessage?.["committeeSectionTwoDescription"]
                        ? "input-error"
                        : ""
                    }`}
                    modules={modules}
                  />
                </div>
              </div>
              {errorMessage?.committeeSectionTwoDescription && (
                <div className="text-danger fw-700 fs-6 mt-1">
                  {errorMessage?.committeeSectionTwoDescription}
                </div>
              )}
            </div>
          </div>
        </div> */}
      </div>

      {/* Session- 3 */}
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <div className="d-flex flex-wrap align-items-center border p-3 gap-3">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
            Section - 3
          </h1>
          <div className="col-4">
            <SelectInput
              options={editorColumn}
              label="Column"
              name="Column"
              handleChange={(e) => handleEditorFilter(e, "Column", 3)}
              value={secThreeFilter?.Column}
            />
          </div>

          <div className="col-4">
            <SelectInput
              options={
                secThreeFilter?.Column === 2
                  ? ColTwoAlginments
                  : ColThreeAlginments
              }
              label="Content Alignment"
              name="ContentAlignment"
              handleChange={(e) => handleEditorFilter(e, "ContentAlignment", 3)}
              value={secThreeFilter?.ContentAlignment}
              isDisabled={
                secThreeFilter?.Column === 1 ||
                secThreeFilter?.Column === undefined
              }
            />
          </div>
          <div className="col-2">
            <Button
              type="submit"
              label="Search"
              status="primary"
              className="mt-4"
              onClick={(e) => {
                handleSearchSection(
                  e,
                  3,
                  "committeeSectionThreeDescription",
                  secThreeFilter?.Column,
                  secThreeFilter?.ContentAlignment
                );
              }}
            />
          </div>
        </div>
        <div className="p-3 row">
          <div className="row mb-4">
            <div className="col-md-12">
              <FroalaEditor
                tag="textarea"
                name="committeeSectionThreeDescription"
                config={config} // your toolbar, plugins, etc.
                model={editorStates?.committeeSectionThreeDescription || ""} // ✅ value binding
                onModelChange={(e) => {
                  // ✅ onChange equivalent
                  handleFroalaEditorChanges(
                    e,
                    "committeeSectionThreeDescription"
                  );
                }}
                className={`editor-block ${errorMessage?.["committeeSectionThreeDescription"]
                    ? "input-error"
                    : ""
                  }`}
              />

              {errorMessage?.committeeSectionThreeDescription && (
                <div className="text-danger fw-700 fs-6 mt-1">
                  {errorMessage?.committeeSectionThreeDescription}
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <div className="p-3 row">
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                label="Title"
                placeholder="Title"
                name="committeeSectionThreeTitle"
                id="committeeSectionThreeTitle"
                value={committeeHomePage?.committeeSectionThreeTitle}
                handleChange={(e) => {
                  handleChange(e);
                }}
                required
                errorMessage={errorMessage}
              />
            </div>

            <div className="col-md-4 d-flex">
              <FileInput
                label="Image"
                name="committeeSectionFourImage"
                imageURL={
                  committeeHomePage?.committeeSectionFourImageToShow ===
                  undefined
                    ? ImageURL + committeeHomePage?.committeeSectionFourImage
                    : committeeHomePage?.committeeSectionFourImageToShow
                }
                handleFileChange={(e) => {
                  handleChange(e, "committeeSectionFourImageToShow");
                }}
              />
            </div>

            <div className="mt-2">
              <label
                className={`form-label col-form-label  w-100 fs-5 form-label-custom-visible `}
              >
                Description {<span className="text-danger">*</span>}
              </label>

              <div className="quill-container" id="toolbar">
                <style>{CustomStyles}</style>
                <div>
                  <ReactQuill
                    name="committeeSectionThreeDescription"
                    theme="snow"
                    value={editorStates?.committeeSectionThreeDescription || ""}
                    onChange={(e) => {
                      handleEditorChanges(
                        e,
                        "committeeSectionThreeDescription"
                      );
                    }}
                    className={`editor-block ${
                      errorMessage?.["committeeSectionThreeDescription"]
                        ? "input-error"
                        : ""
                    }`}
                    modules={modules}
                  />
                </div>
              </div>
              {errorMessage?.committeeSectionThreeDescription && (
                <div className="text-danger fw-700 fs-6 mt-1">
                  {errorMessage?.committeeSectionThreeDescription}
                </div>
              )}
            </div>
          </div>
        </div> */}
      </div>

      {/* Session- 4 */}
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
          Section - 4
        </h1>
        <div className="p-2 border-bottom ">
          <h1 className="m-0 search-header-color border-dotted p-1 border-bottom">
            Card - 1
          </h1>
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                name="committeeSectionFiveCardOneTitle"
                id="committeeSectionFiveCardOneTitle"
                label="Title"
                placeholder="Title"
                value={committeeHomePage?.committeeSectionFiveCardOneTitle}
                handleChange={(e) => {
                  handleChange(e);
                }}
                // required
                errorMessage={errorMessage}
              />
            </div>

            <div className="col-md-4 d-flex">
              {/* <FileInput
                name="committeeSectionFiveCardOneImage"
                label="Image"
                imageURL={
                  committeeHomePage?.committeeSectionFiveCardOneImageToShow ===
                  undefined
                    ? ImageURL +
                      committeeHomePage?.committeeSectionFiveCardOneImage
                    : committeeHomePage?.committeeSectionFiveCardOneImageToShow
                }
                handleFileChange={(e) => {
                  handleChange(e, "committeeSectionFiveCardOneImageToShow");
                }}
                onClearImage={() => {
                  // clear local state
                  setSectionFiveCardImg1("");

                  // clear Redux state
                  dispatch(
                    committeeActions.updateCommitteeHomePageReponseData({
                      ...committeeHomePage,
                      committeeSectionFiveCardOneImage: "",
                   //   committeeSectionFiveCardOneImageToShow: "",
                    })
                  );
                }}
              /> */}

              <FileInput
                name="committeeSectionFiveCardOneImage"
                label="Image"
                // imageURL={
                //   committeeHomePage?.committeeSectionFiveCardOneImageToShow !==
                //     "undefined" &&
                //   committeeHomePage?.committeeSectionFiveCardOneImageToShow !==
                //     undefined
                //     ? ImageURL +
                //       committeeHomePage?.committeeSectionFiveCardOneImage
                //     : committeeHomePage?.committeeSectionFiveCardOneImageToShow
                // }
                imageURL={
                  committeeHomePage?.committeeSectionFiveCardOneImageToShow
                    ? committeeHomePage.committeeSectionFiveCardOneImageToShow
                    : committeeHomePage?.committeeSectionFiveCardOneImage
                      ? ImageURL +
                      committeeHomePage.committeeSectionFiveCardOneImage
                      : undefined
                }
                handleFileChange={(e) => {
                  handleChange(e, "committeeSectionFiveCardOneImageToShow");
                }}
                // required
                onClearImage={() => {
                  // clear local file state
                  setSectionFiveCardImg1("");

                  // clear Redux state completely
                  dispatch(
                    committeeActions.updateCommitteeHomePageReponseData({
                      ...committeeHomePage,
                      committeeSectionFiveCardOneImage: "",
                      committeeSectionFiveCardOneImageToShow: "",
                    })
                  );
                }}
              />
            </div>

            <div className="quill-container" id="toolbar">
              {/* <style>{CustomStyles}</style> */}
              <div>
                {/* <ReactQuill
                  name="committeeSectionFiveCardOneDescription"
                  theme="snow"
                  value={
                    editorStates?.committeeSectionFiveCardOneDescription || ""
                  }
                  onChange={(e) => {
                    handleEditorChanges(
                      e,
                      "committeeSectionFiveCardOneDescription"
                    );
                  }}
                  modules={modules}
                /> */}
                <FroalaEditor
                  tag="textarea"
                  name="committeeSectionFiveCardOneDescription"
                  config={config} // your toolbar, plugins, etc.
                  model={
                    editorStates?.committeeSectionFiveCardOneDescription || ""
                  } // ✅ value binding
                  onModelChange={(e) => {
                    // ✅ onChange equivalent
                    handleFroalaEditorChanges(
                      e,
                      "committeeSectionFiveCardOneDescription"
                    );
                  }}
                  className={`editor-block ${errorMessage?.["committeeSectionFiveCardOneDescription"]
                      ? "input-error"
                      : ""
                    }`}
                />
              </div>
            </div>
            {errorMessage?.committeeSectionFiveCardOneDescription && (
              <div className="text-danger fw-700 fs-6 mt-1">
                {errorMessage?.committeeSectionFiveCardOneDescription}
              </div>
            )}
          </div>
        </div>

        <div className="p-2 border-bottom ">
          <h1 className="m-0 search-header-color border-dotted p-1 border-bottom">
            Card - 2
          </h1>
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                label="Title"
                placeholder="Title"
                name="committeeSectionFiveCardTwoTitle"
                id="committeeSectionFiveCardTwoTitle"
                value={committeeHomePage?.committeeSectionFiveCardTwoTitle}
                handleChange={(e) => {
                  handleChange(e);
                }}
                errorMessage={errorMessage}
              //required
              />
            </div>

            <div className="col-md-4 d-flex">
              <FileInput
                name="committeeSectionFiveCardTwoImage"
                label="Image"
                // imageURL={
                //   committeeHomePage?.committeeSectionFiveCardTwoImageToShow ===
                //   undefined
                //     ? ImageURL +
                //       committeeHomePage?.committeeSectionFiveCardTwoImage
                //     : committeeHomePage?.committeeSectionFiveCardTwoImageToShow
                // }
                imageURL={
                  committeeHomePage?.committeeSectionFiveCardTwoImageToShow
                    ? committeeHomePage.committeeSectionFiveCardTwoImageToShow
                    : committeeHomePage?.committeeSectionFiveCardTwoImage
                      ? ImageURL +
                      committeeHomePage.committeeSectionFiveCardTwoImage
                      : undefined
                }
                handleFileChange={(e) => {
                  handleChange(e, "committeeSectionFiveCardTwoImageToShow");
                }}
                onClearImage={() => {
                  // clear local file state
                  setSectionFiveCardImg2("");

                  // clear Redux state completely
                  dispatch(
                    committeeActions.updateCommitteeHomePageReponseData({
                      ...committeeHomePage,
                      committeeSectionFiveCardTwoImage: "",
                      committeeSectionFiveCardTwoImageToShow: "", // 👈 MUST also clear this
                    })
                  );
                }}
              />
            </div>
            <div className="quill-container" id="toolbar">
              {/* <style>{CustomStyles}</style> */}
              <div className="">
                {/* <ReactQuill
                  name="committeeSectionFiveCardTwoDescription"
                  theme="snow"
                  value={
                    editorStates?.committeeSectionFiveCardTwoDescription || ""
                  }
                  onChange={(e) => {
                    handleEditorChanges(
                      e,
                      "committeeSectionFiveCardTwoDescription"
                    );
                  }}
                  className={`editor-block ${
                    errorMessage?.["committeeSectionFiveCardTwoDescription"]
                      ? "input-error"
                      : ""
                  }`}
                  modules={modules}
                /> */}
                <FroalaEditor
                  tag="textarea"
                  name="committeeSectionFiveCardTwoDescription"
                  config={config} // your toolbar, plugins, etc.
                  model={
                    editorStates?.committeeSectionFiveCardTwoDescription || ""
                  } // ✅ value binding
                  onModelChange={(e) => {
                    // ✅ onChange equivalent
                    handleFroalaEditorChanges(
                      e,
                      "committeeSectionFiveCardTwoDescription"
                    );
                  }}
                  className={`editor-block ${errorMessage?.["committeeSectionFiveCardTwoDescription"]
                      ? "input-error"
                      : ""
                    }`}
                />
              </div>
            </div>
            {errorMessage?.committeeSectionFiveCardTwoDescription && (
              <div className="text-danger fw-700 fs-6 mt-1">
                {errorMessage?.committeeSectionFiveCardTwoDescription}
              </div>
            )}
          </div>
        </div>
        <div className="p-2 border-bottom ">
          <h1 className="m-0 search-header-color border-dotted p-1 border-bottom">
            Card - 3
          </h1>
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                label="Title"
                placeholder="Title"
                value={committeeHomePage?.committeeSectionFiveCardThreeTitle}
                name="committeeSectionFiveCardThreeTitle"
                id="committeeSectionFiveCardThreeTitle"
                handleChange={(e) => {
                  handleChange(e);
                }}
                errorMessage={errorMessage}
              //  required
              />
            </div>

            <div className="col-md-4 d-flex">
              <FileInput
                name="committeeSectionFiveCardThreeImage"
                label="Image"
                // imageURL={
                //   committeeHomePage?.committeeSectionFiveCardThreeImageToShow ===
                //   undefined
                //     ? ImageURL +
                //       committeeHomePage?.committeeSectionFiveCardThreeImage
                //     : committeeHomePage?.committeeSectionFiveCardThreeImageToShow
                // }
                imageURL={
                  committeeHomePage?.committeeSectionFiveCardThreeImageToShow
                    ? committeeHomePage.committeeSectionFiveCardThreeImageToShow
                    : committeeHomePage?.committeeSectionFiveCardThreeImage
                      ? ImageURL +
                      committeeHomePage.committeeSectionFiveCardThreeImage
                      : undefined
                }
                handleFileChange={(e) => {
                  handleChange(e, "committeeSectionFiveCardThreeImageToShow");
                }}
                onClearImage={() => {
                  // clear local file state
                  setSectionFiveCardImg3("");

                  // clear Redux state completely
                  dispatch(
                    committeeActions.updateCommitteeHomePageReponseData({
                      ...committeeHomePage,
                      committeeSectionFiveCardThreeImage: "",
                      committeeSectionFiveCardThreeImageToShow: false, // 👈 MUST also clear this
                    })
                  );
                }}
              />
            </div>
            <div className="quill-container" id="toolbar">
              {/* <style>{CustomStyles}</style> */}
              <div className="">
                {/* <ReactQuill
                  name="committeeSectionFiveCardThreeDescription"
                  theme="snow"
                  value={
                    editorStates?.committeeSectionFiveCardThreeDescription || ""
                  }
                  onChange={(e) => {
                    handleEditorChanges(
                      e,
                      "committeeSectionFiveCardThreeDescription"
                    );
                  }}
                  className={`editor-block ${
                    errorMessage?.["committeeSectionFiveCardThreeDescription"]
                      ? "input-error"
                      : ""
                  }`}
                  modules={modules}
                /> */}
                <FroalaEditor
                  tag="textarea"
                  name="committeeSectionFiveCardThreeDescription"
                  config={config} // your toolbar, plugins, etc.
                  model={
                    editorStates?.committeeSectionFiveCardThreeDescription || ""
                  } // ✅ value binding
                  onModelChange={(e) => {
                    // ✅ onChange equivalent
                    handleFroalaEditorChanges(
                      e,
                      "committeeSectionFiveCardThreeDescription"
                    );
                  }}
                  className={`editor-block ${errorMessage?.["committeeSectionFiveCardThreeDescription"]
                      ? "input-error"
                      : ""
                    }`}
                />
              </div>
            </div>
            {errorMessage?.committeeSectionFiveCardThreeDescription && (
              <div className="text-danger fw-700 fs-6 mt-1">
                {errorMessage?.committeeSectionFiveCardThreeDescription}
              </div>
            )}
          </div>
        </div>
        <div className="p-2 border-bottom ">
          <h1 className="m-0 search-header-color border-dotted p-1 border-bottom">
            Card - 4
          </h1>
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                label="Title"
                placeholder="Title"
                value={committeeHomePage?.committeeSectionFiveCardFourTitle}
                name="committeeSectionFiveCardFourTitle"
                id="committeeSectionFiveCardFourTitle"
                handleChange={(e) => {
                  handleChange(e);
                }}
                // required
                errorMessage={errorMessage}
              />
            </div>

            <div className="col-md-4 d-flex">
              <FileInput
                name="committeeSectionFiveCardFourImage"
                label="Image"
                // imageURL={
                //   committeeHomePage?.committeeSectionFiveCardFourImageToShow ===
                //   undefined
                //     ? ImageURL +
                //       committeeHomePage?.committeeSectionFiveCardFourImage
                //     : committeeHomePage?.committeeSectionFiveCardFourImageToShow
                // }
                imageURL={
                  committeeHomePage?.committeeSectionFiveCardFourImageToShow
                    ? committeeHomePage.committeeSectionFiveCardFourImageToShow
                    : committeeHomePage?.committeeSectionFiveCardFourImage
                      ? ImageURL +
                      committeeHomePage.committeeSectionFiveCardFourImage
                      : undefined
                }
                handleFileChange={(e) => {
                  handleChange(e, "committeeSectionFiveCardFourImageToShow");
                }}
                onClearImage={() => {
                  debugger;
                  // clear local file state
                  setSectionFiveCardImg4("");

                  // clear Redux state completely
                  dispatch(
                    committeeActions.updateCommitteeHomePageReponseData({
                      ...committeeHomePage,
                      committeeSectionFiveCardFourImage: "",
                      committeeSectionFiveCardFourImageToShow: "",
                      committeeSectionFiveCardOneDescription:
                        editorStates.committeeSectionFiveCardOneDescription,
                      committeeSectionFiveCardTwoDescription:
                        editorStates?.committeeSectionFiveCardTwoDescription,
                      committeeSectionFiveCardThreeDescription:
                        editorStates?.committeeSectionFiveCardThreeDescription,
                      committeeSectionFiveCardFourDescription:
                        editorStates?.committeeSectionFiveCardFourDescription,
                    })
                  );
                }}
              />
            </div>
            <div className="quill-container" id="toolbar">
              {/* <style>{CustomStyles}</style> */}
              <div className="">
                {/* <ReactQuill
                  name="committeeSectionFiveCardFourDescription"
                  theme="snow"
                  value={
                    editorStates?.committeeSectionFiveCardFourDescription || ""
                  }
                  onChange={(e) => {
                    handleEditorChanges(
                      e,
                      "committeeSectionFiveCardFourDescription"
                    );
                  }}
                  className={`editor-block ${
                    errorMessage?.["committeeSectionFiveCardFourDescription"]
                      ? "input-error"
                      : ""
                  }`}
                  modules={modules}
                /> */}
                <FroalaEditor
                  tag="textarea"
                  name="committeeSectionFiveCardFourDescription"
                  config={config} // your toolbar, plugins, etc.
                  model={
                    editorStates?.committeeSectionFiveCardFourDescription || ""
                  } // ✅ value binding
                  onModelChange={(e) => {
                    // ✅ onChange equivalent
                    handleFroalaEditorChanges(
                      e,
                      "committeeSectionFiveCardFourDescription"
                    );
                  }}
                  className={`editor-block ${errorMessage?.["committeeSectionFiveCardFourDescription"]
                      ? "input-error"
                      : ""
                    }`}
                />
              </div>
            </div>
            {errorMessage?.committeeSectionFiveCardFourDescription && (
              <div className="text-danger fw-700 fs-6 mt-1">
                {errorMessage?.committeeSectionFiveCardFourDescription}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Session- 5 */}
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
          Section - 5
        </h1>
        <div className="p-3 row">
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                label="Title"
                placeholder="Title"
                name="committeeSectionSixBannerTitle"
                id="committeeSectionSixBannerTitle"
                handleChange={(e) => {
                  handleChange(e);
                }}
                value={
                  committeeHomePage?.committeeSectionSixBannerTitle
                    ? committeeHomePage?.committeeSectionSixBannerTitle
                    : "Test"
                }
                required
                errorMessage={errorMessage}
              />
            </div>

            <div className="col-md-4 d-flex">
              <FileInput
                name="committeeSectionSixBannerImage"
                id="committeeSectionSixBannerImage"
                label="Background Image"
                handleFileChange={(e) => {
                  handleChange(e, "committeeSectionSixBannerImageToShow");
                }}
                imageURL={
                  committeeHomePage?.committeeSectionSixBannerImageToShow ===
                    undefined
                    ? ImageURL +
                    committeeHomePage?.committeeSectionSixBannerImage
                    : committeeHomePage?.committeeSectionSixBannerImageToShow
                }
              />
            </div>

            <div className="col-md-4">
              <TextInput
                label="Button Label"
                placeholder="Label"
                name="committeeSectionSixButtonLabel"
                id="committeeSectionSixButtonLabel"
                value={committeeHomePage?.committeeSectionSixButtonLabel}
                handleChange={(e) => {
                  handleChange(e);
                }}
                required
                errorMessage={errorMessage}
              />
            </div>
            <div className="col-md-4">
              <TextInput
                label="Button URL"
                placeholder="Button URL"
                name="committeeSectionSixButtonUrl"
                id="committeeSectionSixButtonUrl"
                value={committeeHomePage?.committeeSectionSixButtonUrl}
                handleChange={(e) => {
                  handleChange(e);
                }}
                errorMessage={errorMessage}
                required
              />
            </div>
            <div className="col-md-4">
              <RadioInput
                name="committeeSectionSixButtonTarget"
                label="Button Target"
                options={ButtonTarget}
                handleChange={(e) => handleChange(e)}
                selectedValue={
                  committeeHomePage?.committeeSectionSixButtonTarget
                }
                errorMessage={errorMessage}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3 d-flex justify-content-center align-items-center gap-3">
        <Button
          type="submit"
          label="Submit"
          status="primary"
          disabled={isPending}
        />
        <Button
          type="reset"
          label="Reset"
          status="reset"
          onClick={(e) => {
            handleReset(e);
          }}
        />
      </div>
    </form>
  );
}

export default CommitteeHomePage;
